import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { cn } from '../lib/utils';
import { Check, Paintbrush, Layers } from 'lucide-react';

export const TextureSelector = ({ textureType, onSelect }) => {
  const { t, isRTL } = useLanguage();

  const options = [
    {
      id: 'smooth',
      titleHe: 'גימור חלק',
      titleEn: 'Smooth Finish',
      descHe: 'מראה אחיד ונקי - השתמש בחומר דליל יותר',
      descEn: 'Uniform, clean look - use more diluted material',
      icon: Paintbrush,
      emoji: '✨',
    },
    {
      id: 'textured',
      titleHe: 'טקסטורה',
      titleEn: 'Textured Finish',
      descHe: 'מרקם טבעי ומינרלי - השתמש בחומר סמיך יותר',
      descEn: 'Natural mineral texture - use thicker material',
      icon: Layers,
      emoji: '🪨',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {options.map((option, index) => {
        const Icon = option.icon;
        const isSelected = textureType === option.id;

        return (
          <motion.button
            key={option.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.4 }}
            whileHover={{ scale: 1.02, y: -4 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onSelect(option.id)}
            className={cn(
              'relative p-8 rounded-3xl border-2 transition-all duration-300 text-start',
              isSelected 
                ? 'border-accent bg-accent/5 shadow-glow' 
                : 'border-border/40 hover:border-accent/30 hover:shadow-medium bg-card'
            )}
          >
            {isSelected && (
              <motion.div 
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="absolute top-4 end-4 w-8 h-8 rounded-full bg-accent flex items-center justify-center shadow-lg"
              >
                <Check className="w-5 h-5 text-accent-foreground" />
              </motion.div>
            )}

            <div className="flex items-start gap-5">
              <motion.div 
                className={cn(
                  'w-20 h-20 rounded-2xl flex items-center justify-center text-4xl transition-all duration-300',
                  isSelected 
                    ? 'bg-accent/10' 
                    : 'bg-secondary'
                )}
                whileHover={{ rotate: [0, -5, 5, 0] }}
              >
                {option.emoji}
              </motion.div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {isRTL ? option.titleHe : option.titleEn}
                </h3>
                <p className="text-muted-foreground">
                  {isRTL ? option.descHe : option.descEn}
                </p>
              </div>
            </div>
          </motion.button>
        );
      })}
    </div>
  );
};
